import { render, staticRenderFns } from "./vGesCese.vue?vue&type=template&id=37bf724e&"
import script from "./vGesCese.vue?vue&type=script&lang=js&"
export * from "./vGesCese.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports